"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_label_1 = require("@hotelplan/components.common.label");
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const InputWrapper = styled_components_1.default.div(({ fullWidth }) => ({
    width: fullWidth ? '100%' : 'auto',
}));
const BaseInputWrapper = styled_components_1.default.div({
    position: 'relative',
});
const BaseInput = styled_components_1.default.input(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.inputs.baseInput), components_common_mixins_1.textEllipsis)), ({ hasIcon, theme }) => (hasIcon ? theme.inputs.hasIconMargin : null));
const BaseInputIcon = (0, styled_components_1.default)(components_common_icon_1.Icon)(({ theme, clickable }) => (Object.assign({ position: 'absolute', top: '50%', transform: 'translateY(-50%)', pointerEvents: clickable ? 'auto' : 'none' }, theme.inputs.baseInputIcon)));
const Input = React.forwardRef((props, ref) => {
    const { label, hideLabel, fullWidth, inputRef, icon, iconProps, required, className, children, customLabel } = props, restRawInputProps = __rest(props, ["label", "hideLabel", "fullWidth", "inputRef", "icon", "iconProps", "required", "className", "children", "customLabel"]);
    const { name: inputName } = restRawInputProps;
    return (React.createElement(InputWrapper, { ref: ref, className: className, fullWidth: fullWidth },
        customLabel ? (customLabel) : (React.createElement(components_common_label_1.Label, { htmlFor: inputName, hideLabel: hideLabel },
            label,
            " ",
            required ? React.createElement("span", null, "*") : '')),
        React.createElement(BaseInputWrapper, { className: "base-input-wrapper" },
            React.createElement(BaseInput, Object.assign({ ref: inputRef, className: "input", hasIcon: !!icon }, restRawInputProps)),
            React.createElement(React.Fragment, null,
                icon ? (React.createElement(BaseInputIcon, Object.assign({ name: `${icon.name}`, size: icon.size }, iconProps, { className: "input-icon" }))) : null,
                children))));
});
Input.displayName = 'BaseInput';
exports.default = Input;
//# sourceMappingURL=BaseInput.js.map